/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_TitleInputs */

const es_privacy_policy_security_title = /** @type {(inputs: Privacy_Policy_Security_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Seguridad de los Datos`)
};

const en_privacy_policy_security_title = /** @type {(inputs: Privacy_Policy_Security_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8. Data Security`)
};

/**
* | output |
* | --- |
* | "8. Data Security" |
*
* @param {Privacy_Policy_Security_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_title = /** @type {((inputs?: Privacy_Policy_Security_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_title(inputs)
	return en_privacy_policy_security_title(inputs)
});
export { privacy_policy_security_title as "privacy_policy.security.title" }